import React from 'react';
import { Grid, Typography, Box, Link } from "@material-ui/core";
import styled from 'styled-components'
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import TextfieldAtom from '../../component/Textfield/index.jsx'
import { makeStyles } from '@material-ui/styles';
import Avatar from '@mui/material/Avatar';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FooterBar from './../../component/FooterAtom/index'
import Edit_Profile from '../edit_profile/Edit_Profile.js';
import { useHistory, useLocation } from 'react-router-dom';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { useState, useEffect } from "react";
// import { useHistory, useLocation } from "react-router-dom";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import firebase from "../../config/firebase/index";
import ReactGA from 'react-ga';
import TnC from '../Terms_And_Condition/Terms_And_Condition.js';
import encSecret from '../../config/encryption/index.js';
import NoFollowMeta from '../../component/NofollowMeta/index.jsx';
var CryptoJS = require("crypto-js");


// import { useHistory, useLocation } from "react-router-dom";



const Profile = () => {
    const classes = useStyles();
    const history = useHistory();
    // const location = useLocation();
    const [name, setName] = useState("");
    const [PhoneNO, setPhoneNo] = useState("");
    const [city, setCity] = useState("");
    const [img, setImg] = useState("");
    const [userId, setUserId] = useState("");
    const [isDealer, setIsDealer] = useState("");

    const profileEdit = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    const profile = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }



    const logout = () => {
        profile('Logout', 'Click', 'Logout link');
        firebase
            .auth()
            .signOut()
            .then(() => {
                history.push("/");
                localStorage.clear();
                window.location.reload();
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const currentUser = () => {

        firebase.database().ref("Users").orderByChild("PhoneNo")
            .equalTo(localStorage.getItem("Phone Number")).once("value", snapshot => {

                const userData = snapshot.val();
                // const user = userData;

                const user = [];
                for (const key in userData) {

                    const quoteObj = {
                        id: key,
                        ...userData[key],
                    };
                    user.push(quoteObj);
                }
                localStorage.setItem("user", JSON.stringify(user));
                // if (userData) {
                //     // localStorage.setItem("user", JSON.stringify(user));
                //     // localStorage.setItem("isLoggedIn", true);
                //     return user;
                // }
                // else {
                //     history.push("/signup");
                //     // localStorage.setItem("isLoggedIn", true);

                //     // localStorage.setItem("loginFlag", false);

                // }

            })
    }
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);


    useEffect(() => {
        currentUser();
        const user = JSON.parse(localStorage.getItem("user"));
        setUserId(user[0].id);
        setName(CryptoJS.AES.decrypt(user[0].Name, encSecret.key).toString(CryptoJS.enc.Utf8));
        setPhoneNo(user[0].PhoneNo);
        setCity(user[0].City);
        setImg(user[0].img);
        setIsDealer(user[0].dealerFlag);
        forceUpdate();
    });

    const renderEditProfile = () => {
        profileEdit('Edit Profile', 'Click', 'Edit profile button');
        history.push({ pathname: "/editprofile", state: { userId: userId } });
    }

    const renderTnc = () => {
        history.push({ pathname: "/t&c" });
    }

    const renderPrivacyPolicy = () => {
        history.push({ pathname: "/privacy-policy" });
    }


    return (
        <Grid style={{ textAlign: "center", margin: "auto", maxWidth: 540 }}>
            <NoFollowMeta />
            
                <Grid style={{margin: "20px 40px"}}>
                    <Box mt={2}>
                        <Typography variant="h5" style={{ fontWeight: 600 }} gutterBottom className={classes.purpuleColor}>
                            प्रोफाइल
                        </Typography>
                    </Box>

                    <Typography className={classes.border}></Typography>

                    <Box>


                        <Box mb={3} mt={3} className={classes.farmerImage}>
                            <Avatar sx={{ width: '130px', height: '130px', }} className={classes.image} alt="farmer" src={img} />
                            {/* src={img} */}
                        </Box>

                        <Box>
                            <Typography variant='body1' style={{ fontWeight: 600, marginBottom: "-20px" }}>{name}</Typography>
                        </Box>

                        <Box mb={3}>
                            <Typography variant="subtitle1" gutterBottom className={classes.labelAlign}>
                                {PhoneNO} | {city}
                            </Typography>

                        </Box>



                    </Box>

                    <Link href="/editprofile" className={classes.contetnArrange1} >
                        <ButtonAtom
                            name="प्रोफाइल Edit करे "
                            onClick={renderEditProfile}
                        />

                    </Link>

                    <Box mb={3}>

                        <Box>
                            <Box className={classes.contentArrange}>

                                <Box mt={2} className={classes.iconFront}>

                                    <ButtonAtom
                                        name="गोपनीयता निति "
                                        className={classes.alignTextLeft}
                                        cclass="templateButton3"
                                        onClick={renderPrivacyPolicy}
                                        startIcon={<ArrowForwardIosIcon className={classes.iconInFront} />}

                                    />
                                </Box>
                                <Box mt={2}>
                                    <ButtonAtom
                                        name="नियम और शर्ते "
                                        cclass="templateButton3"
                                        onClick={renderTnc}
                                        startIcon={<ArrowForwardIosIcon className={classes.iconInFront} />}
                                    />
                                </Box>
                                <Box mt={2}>
                                    {/* <TextfieldAtom color="red" placeholder="लॉगआउट करे  " /> */}
                                    <ButtonAtom
                                        name="लॉगआउट करे  "
                                        cclass="templateButton3"
                                        onClick={logout} />
                                </Box>
                                {/* <Box mt={4}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography className={classes.heading}> गोपनीयता निति </Typography>
                            </AccordionSummary>

                        </Accordion>
                    </Box> */}

                                {/* <Box mt={4}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography className={classes.heading}>नियम और शर्ते </Typography>
                            </AccordionSummary>

                        </Accordion>
                    </Box> */}

                            </Box>


                        </Box>
                    </Box>




                </Grid >
                <Box>
                    <FooterBar isDealer={isDealer} active={[0, 0, 0, 0]} />
                </Box>

            </Grid>

    )
};

const useStyles = makeStyles((theme) => ({
    commonFullSection: {
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    commonMidSection: {
        maxWidth: 540,
        background: '#fff',
        // boxShadow: '0 0 5px #eee',
        padding: 20,
        boxSizing: 'border-box',
        textAlign: 'center',
        marginTop: '-220px',
        width: 'calc(100% - 60px)',
        justifyContent: 'flex-start',
    },
    marginTopAuto: {
        marginTop: 'auto',
    },
    labelAlign: {
        textAlign: 'center',
        marginTop: 30,
        justifyContent: 'center',
    },
    purpuleColor: {
        color: '#53252f',
    },
    button1: {
        marginLeft: 25,
        marginRight: 25,
    },
    farmerImage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        size: '100%',
    },
    commonSectionBuild: {
        maxWidth: 540,
        float: 'none',
        margin: '0 auto',
        padding: '0 15px',
        boxSizing: 'border-box',
    },
    headerBrowser2: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 90px',
        boxSizing: 'border-box',
        alignItems: 'center',
        position: 'relative',
        '& input': {
            paddingLeft: 50,
        }

    },
    headerBrowser3: {
        position: 'absolute',
        top: 25,
        right: 30,
    },
    contetnArrange: {
        width: '100%',
        padding: '10px 90px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        [theme.breakpoints.down('xs')]: {
            padding: '10px 0',
        },
        '& div': {
            width: '100%'
        },

    },
    image: {
        width: '150px',
        height: '150px',
        borderRadius: '50%',
        position: 'relative',
        overflow: 'hidden',
    },
    circularImg: {
        minWidth: '100%',
        minHeight: '100%',
        width: 'auto%',
        height: 'auto',
        position: 'absolute',
        right: '-10%',
        top: '50%',
        bottom: '50%',

        // -webkitTransform: 'translate(-50%, -50%)',
        // -mozTransform: 'translate(-50%, -50%)',
        // -msTransform: 'translate(-50%, -50%)' ,
        // transform: 'translate(-50%, -50%)',
    },
    border: {
        borderBottom: 'solid 1px #ddd',

    },
    iconFront: {
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
        display: 'inherit',
        alignItems: 'inherit',
        justifyContent: 'inherit',
    },
    iconFront1: {
        position: 'absolute',

        top: '20px',
        Right: '30px',
    },
    textLeft: {
        marginRight: '40px',
        textAlign: 'left',
    },
    iconInFront: {
        position: 'absolute',
        right: 10,

        bottom: '12px'
    },
    alignTextLeft: {
        textAlign: 'left',
        alignItems: 'left',
    },
    contetnArrange1: {
        alignItems: 'center',
        justifyContent: 'inherit',
        textAlign: 'center',

    }



}));


export default Profile;